/**
 * Shopify webhook geri çağrı adresi — TEK KAYNAK (sunucu `src/shopify/webhook-plani.ts`
 * ve panel `Ayarlar.tsx` aynı fonksiyonu kullanır). Hiçbir şey import etmez.
 *
 * Ölçülen kusur (8 Eylül 2026, canlı): "dış adres" alanına tam webhook adresi
 * yazıldığında sunucu ve panel ayrı ayrı `/webhooks/shopify` ekliyor, ekranda ve
 * abonelikte `…/webhooks/shopify/webhooks/shopify` çıkıyordu. Artık dış adres
 * normalize edilir: sondaki `/`, `/webhooks/shopify` ve sorgu/parça atılır; kök
 * (`https://host[/altyol]`) kalır ve yol BİR kez eklenir.
 */

export const WEBHOOK_YOLU = '/webhooks/shopify';

/** Kullanıcının yazdığı dış adresi köke indirger: sondaki `/`, `/webhooks/shopify`, `?…`, `#…` gider. */
export function disAdresiNormalize(disAdres: string): string {
  let d = disAdres.trim();
  d = d.replace(/[?#].*$/, '');
  d = d.replace(/\/+$/, '');
  d = d.replace(/\/webhooks\/shopify$/i, '');
  return d.replace(/\/+$/, '');
}

export function disAdresGecerliMi(disAdres: string): boolean {
  try {
    const u = new URL(disAdresiNormalize(disAdres));
    if (u.protocol !== 'https:') return false;
    const h = u.hostname.toLowerCase();
    return h !== 'localhost' && !h.startsWith('127.') && !h.endsWith('.local');
  } catch {
    return false;
  }
}

/** Shopify'a tanıtılacak tam adres; dış adres geçersizse `null`. */
export function geriCagriAdresi(disAdres: string): string {
  return `${disAdresiNormalize(disAdres)}${WEBHOOK_YOLU}`;
}
